export * from './FolderMinusIcon';
export * from './FolderMinusIcon16Light';
export * from './FolderMinusIcon16Regular';
export * from './FolderMinusIcon16Solid';
export * from './FolderMinusIcon20Light';
export * from './FolderMinusIcon20Regular';
export * from './FolderMinusIcon20Solid';
export * from './FolderMinusIcon24Regular';
export * from './FolderMinusIcon24Solid';
export * from './FolderMinusIcon32Regular';
export * from './FolderMinusIcon64Regular';
